import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useGetNowTimezone } from "../../pages/Personal/hooks/personal.hook";
import CustomTabs from "../CustomTabs";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
dayjs.extend(weekday);

function CustomDateTabs({ filterValue, setFilterValue, startDateKey, endDateKey }) {
  const { t } = useTranslation();
  const { data: currentTimezone } = useGetNowTimezone({});

  const [activeTab, setActiveTab] = useState(
    `${dayjs().format("YYYY-MM-DD 00:00:00")}-${dayjs().format("YYYY-MM-DD 23:59:59")}`,
  );
  useEffect(() => {
    if (filterValue) {
      const _dateRange = `${filterValue[startDateKey]}-${filterValue[endDateKey]}`;
      if (_dateRange !== activeTab) {
        setActiveTab(_dateRange);
      }
    }
  }, [filterValue]);

  const dateTabItems = [
    {
      key: `${dayjs().tz(currentTimezone?.timezone).format("YYYY-MM-DD 00:00:00")}-${dayjs().format(
        "YYYY-MM-DD 23:59:59",
      )}`,
      title: t("global.today"),
      value_enum: [
        dayjs().tz(currentTimezone?.timezone).format("YYYY-MM-DD 00:00:00"),
        dayjs().format("YYYY-MM-DD 23:59:59"),
      ],
    },
    {
      key: `${dayjs().subtract(1, "day").format("YYYY-MM-DD 00:00:00")}-${dayjs()
        .subtract(1, "day")
        .format("YYYY-MM-DD 23:59:59")}`,
      title: t("global.yesterday"),
      value_enum: [
        dayjs().subtract(1, "day").format("YYYY-MM-DD 00:00:00"),
        dayjs().subtract(1, "day").format("YYYY-MM-DD 23:59:59"),
      ],
    },
    {
      key: `${dayjs()
        .tz(currentTimezone?.timezone)
        .add(dayjs().tz(currentTimezone?.timezone).isoWeekday() * -1 + 1, "day")
        .format("YYYY-MM-DD 00:00:00")}-${dayjs()
        .tz(currentTimezone?.timezone)
        .add(7 - dayjs().tz(currentTimezone?.timezone).isoWeekday(), "day")
        .format("YYYY-MM-DD 23:59:59")}`,
      title: t("global.thisWeek"),
      value_enum: [
        dayjs()
          .tz(currentTimezone?.timezone)
          .add(dayjs().tz(currentTimezone?.timezone).isoWeekday() * -1 + 1, "day")
          .format("YYYY-MM-DD 00:00:00"),
        dayjs()
          .tz(currentTimezone?.timezone)
          .add(7 - dayjs().tz(currentTimezone?.timezone).isoWeekday(), "day")
          .format("YYYY-MM-DD 23:59:59"),
      ],
    },
    {
      key: `${dayjs()
        .tz(currentTimezone?.timezone)
        .add(dayjs().tz(currentTimezone?.timezone).isoWeekday() * -1 - 6, "day")
        .format("YYYY-MM-DD 00:00:00")}-${dayjs()
        .tz(currentTimezone?.timezone)
        .add(dayjs().tz(currentTimezone?.timezone).isoWeekday() * -1, "day")
        .format("YYYY-MM-DD 23:59:59")}`,
      title: t("global.lastWeek"),
      value_enum: [
        dayjs()
          .tz(currentTimezone?.timezone)
          .add(dayjs().tz(currentTimezone?.timezone).isoWeekday() * -1 - 6, "day")
          .format("YYYY-MM-DD 00:00:00"),
        dayjs()
          .tz(currentTimezone?.timezone)
          .add(dayjs().tz(currentTimezone?.timezone).isoWeekday() * -1, "day")
          .format("YYYY-MM-DD 23:59:59"),
      ],
    },
    {
      key: `${dayjs()
        .tz(currentTimezone?.timezone)
        .startOf("month")
        .format("YYYY-MM-DD 00:00:00")}-${dayjs()
        .tz(currentTimezone?.timezone)
        .endOf("month")
        .format("YYYY-MM-DD 23:59:59")}`,
      title: t("global.thisMonth"),
      value_enum: [
        dayjs().tz(currentTimezone?.timezone).startOf("month").format("YYYY-MM-DD 00:00:00"),
        dayjs().tz(currentTimezone?.timezone).endOf("month").format("YYYY-MM-DD 23:59:59"),
      ],
    },
    {
      key: `${dayjs()
        .tz(currentTimezone?.timezone)
        .startOf("month")
        .subtract(1, "month")
        .format("YYYY-MM-DD 00:00:00")}-${dayjs()
        .tz(currentTimezone?.timezone)
        .startOf("month")
        .subtract(1, "day")
        .format("YYYY-MM-DD 23:59:59")}`,
      title: t("global.lastMonth"),
      value_enum: [
        dayjs()
          .tz(currentTimezone?.timezone)
          .startOf("month")
          .subtract(1, "month")
          .format("YYYY-MM-DD 00:00:00"),
        dayjs()
          .tz(currentTimezone?.timezone)
          .startOf("month")
          .subtract(1, "day")
          .format("YYYY-MM-DD 23:59:59"),
      ],
    },
  ];

  const onDateChange = (key) => {
    const selectedDate = dateTabItems.find((item) => item.key === key);
    if (selectedDate) {
      setFilterValue((prevState) => {
        return {
          ...prevState,
          [startDateKey]: selectedDate.value_enum[0],
          [endDateKey]: selectedDate.value_enum[1],
        };
      });
    }
    setActiveTab(key);
  };
  return <CustomTabs activeKey={activeTab} onTabChange={onDateChange} tabItems={dateTabItems} />;
}

export default CustomDateTabs;
